module.exports = __webpack_public_path__ + "static/Vons_pin-8cc76ad97c1c5308ecbfbafc1dd0e716.png";